/* ============================================================
   TASK-323 — Brand Kit "AI media" lock decision. Pure, framework-free so it
   can be unit-tested without mounting BrandKitScreen (no @testing-library /
   jsdom in this repo — see src/lib/imageAllowance.js, textAllowance.js,
   postingPlan.js for the same pure-decision convention).

   Brand Kit generation shares the premium_visuals_monthly allowance with
   post-image regenerations (a DIFFERENT counter than New Post's
   image_generations_monthly / deriveImageAllowance). "Locked" means the
   allowance is CONFIRMED zero — never merely unknown/loading, so the
   compact locked row doesn't flash for an account whose entitlements
   haven't finished fetching yet.
   ============================================================ */
export function isBrandKitMediaLocked(allowance) {
  return Boolean(allowance) && allowance.limit === 0;
}

/**
 * Fix list item 12: the decision BrandKitScreen.jsx actually needs starts
 * from the full `entitlements` object (usage.premium_visuals_monthly), not
 * an already-extracted allowance — this is the "real derive helper" so
 * tests exercise the same extraction the screen does, not just the inner
 * zero-check.
 */
export function deriveBrandKitMediaLock(entitlements) {
  const allowance = entitlements?.usage?.premium_visuals_monthly || null;
  return isBrandKitMediaLocked(allowance);
}
